<template>
  <hr v-if="separator" class="dropdown-divider">
  <a v-else-if="!custom && !hasLink" class="dropdown-item anchor" :class="anchorClasses" :role="ariaRoleItem" tabindex="0" href="javascript: void(0)" @click.stop.prevent="selectItem">
    <slot />
  </a>
  <div v-else :class="itemClasses" :role="ariaRoleItem" tabindex="0" @click.stop.prevent="selectItem">
    <slot />
  </div>
</template>

<script>
  export default {
    name: 'DDropdownItem',
    props: {
      value: {
        type: [String, Number, Boolean, Object, Array, Symbol, Function],
        default: null,
      },
      color: {
        type: String,
        default: 'primary-500',
      },
      separator: Boolean,
      disabled: Boolean,
      custom: Boolean,
      paddingless: Boolean,
      hasLink: Boolean,
      ariaRole: {
        type: String,
        default: 'listitem',
        validator: (value) => [null, 'menuitem', 'listitem'].includes(value),
      },
    },

    computed: {
      anchorClasses() {
        return [
          [`anchor-color--${this.color}`], {
            'is-disabled': this.$parent.disabled || this.disabled,
            'is-paddingless': this.paddingless,
            'is-active': this.value !== null && this.value === this.$parent.selected,
          }];
      },

      itemClasses() {
        return {
          'dropdown-item': !this.hasLink,
          'is-disabled': this.disabled,
          'is-paddingless': this.paddingless,
          'is-active': this.value !== null && this.value === this.$parent.selected,
          'has-link': this.hasLink,
        };
      },

      ariaRoleItem() {
        return this.ariaRole === 'menuitem' || this.ariaRole === 'listitem' ? this.ariaRole : null;
      },

      isClickable() {
        return !this.$parent.disabled && !this.separator && !this.disabled && !this.custom;
      },
    },

    created() {
      if (!this.$parent.$data._isDropdown) {
        this.$destroy();
        throw new Error('You should wrap DDropdownItem on a DDropdown');
      }
    },

    methods: {
      selectItem() {
        if (!this.isClickable) return;
        this.$parent.selectItem(this.value);
        this.$emit('click');
      },
    },
  };
</script>